export default __webpack_public_path__ + "/dist/images/membership-inactive.f6959457beaf2a00b5fd64ea0ebaf890.svg";